import React, {Component} from 'react'
import Base from '../BaseComponent'

import {
  NavLink,
  Link,
  BrowserHistory,
  withRouter
} from 'react-router-dom';

// Utils
import Site, {SiteModifier_} from '../../utils/Site';
import Window from '../../utils/Window';

// Components
import FadeIn from '../FadeIn';
import Loader from '../Loader';
import Navigation from '../Navigation';
import Template from '../Template';
import Icon from '../Icon';
import Back from '../Back';
import List from '../Lists';
import Content from '../Content';
import ActionLogger from '../ActionLogger';

import moment from 'moment'

// HOC
import withData from '../../utils/withData';

class Layout extends Component {

  render () {


    const getYear = () => {
      return moment().tz('America/New_York').format('Y');
    }

    return (
      <FadeIn>
      <Site routeModifier={this.props.location.pathname == '/' ? 'home' : this.props.location.pathname}>

      <header className="Site-head">

        <SiteModifier_ toggle="menu">

        <div className="Site-burger">
          {/*<Icon type="close" />*/}
        </div>
        </SiteModifier_>

        <div className="Site-logo">
        <Link to={'/'}>
          <Icon type="arrow-down-yellow" />
          <div className="Logo Logo--welcome"></div>
        </Link>
        </div>

        <div className="Site-signup">
        <ActionLogger category="Signup" action="Top Right Click" label={'Signup button press from '+ this.props.location.pathname}>
        <Link to={'/sign-up'}>
          <Icon type="newsletter" />
        </Link>
        </ActionLogger>
        </div>

        <div className="Site-back">
        <Back>
          <Icon type="arrow-left-yellow" />
        </Back>
        </div>

        <div className="Site-menu">

          {/*<SiteModifier_ demodifier="menu">
            <div className="Site-close">
              <Icon type="close" />
            </div>
          </SiteModifier_>*/}

          <SiteModifier_ demodifier="menu">
            <div className="Site-nav">
              <Navigation modifiers={['main']} items={this.props.datastore.get('navigation').main} />
            </div>
          </SiteModifier_>
        </div>
        </header>
        <div className="Site-body">
          <Template entries={this.props.datastore.get('entries')} />
        </div>

        <div className="Site-foot">

          <div className="Site-foot-sections">
            <div className="Site-foot-section  Site-foot-section--1">
            <Navigation modifiers={['foot']} items={this.props.datastore.get('navigation').footer} />
            </div>

            <div className="Site-foot-section  Site-foot-section--2">

              <List modifiers={['socialIcons']}>
                <li className="List-item  List-item--instagram">
                  <div className="square">
                    <a href="https://www.instagram.com/thefenway/" target="_blank"><Icon type="instagram-white"/></a>
                    </div>
                </li><li className="List-item  List-item--twitter">
                  <div className="square">
                  <a href="https://twitter.com/TheFenway" target="_blank"><Icon type="twitter-white"/></a>
                  </div>
                </li><li className="List-item  List-item--facebook">
                  <div className="square">
                  <a href="https://www.facebook.com/thefenwayneighborhood/" target="_blank"><Icon type="facebook-white"/></a>
                  </div>
                </li><li className="List-item  List-item--copyright">
                  <Content modifier={'home'}>
                    <small>© {getYear()} samuels & associates</small>
                  </Content>
                </li>
              </List>

            </div>
          </div>
        </div>
      </Site>
      </FadeIn>
    )
  }
}

export default withRouter(Layout)



// WEBPACK FOOTER //
// ./src/js/components/Layout/Layout.jsx